export const ACCESS_TOKEN_KEY = '@aToken'
export const REFRESH_TOKEN_KEY = '@rToken'
export const LANG_KEY = '@lang'

export const DEFAULT_LANG = 'he'

export const API_ENDPOINT =
  import.meta.env.VITE_API_ENDPOINT || 'https://server.onelease-crm.com'
export const GRAPHQL_ENDPOINT = `${API_ENDPOINT}/graphql/`

export const DATE_TIME_FORMAT = 'DD/MM/YYYY, HH:mm'
export const DATE_FORMAT = 'DD/MM/YYYY'
export const SEARCH_FULL_PATH_SCHEMA = '/:customerId/:path/:id'
export const SEARCH_PATH_SCHEMA = '/:customerId/:path'
